import { ISlip } from '../bet-generation/models';
import { getBetslipTypeFromId } from '../bet-generation/services/slip.utils';
import { TrackingSlipData } from './tracking.models';

export function mapSlipToTrackingSlip(slip: ISlip): TrackingSlipData {
    return {
        stake: slip.stake,
        type: getBetslipTypeFromId(slip.slipId),
        picks: Object.values(slip.slipPicks).map((p) => p.pick),
    };
}
